export default "__VITE_ASSET__CWVs4dbU__"